export enum DynamicFormFieldType {
    RadioGroup = 'radio-group',
    Button = 'button',
    DatePicker = 'date',
    Header = 'header',
    Number = 'number',
    TextArea = 'textarea',
    CheckBoxGroup = 'checkbox-group',
    Text = 'text',
    Select = 'select',
    Paragraph = 'paragraph'
}

export enum DynamicFormFieldSubType {
    H1 = 'h1',
    H2 = 'h2',
    H3 = 'h3',
    H4 = 'h4',
    H5 = 'h5',
    H6 = 'h6',
    Paragraph = 'p',
    Quote = 'blockquote',
    Output = 'output',
    Canvas = 'canvas',
    Text = 'text',
    Password = 'password',
    Email = 'email',
    Color = 'color',
    Phone = 'tel',
    Submit = 'submit',
    Clear = 'clear'
}

export enum FeedBackType {
    NONE = '',
    WP_DOWNLOAD = 'wp-download'
}
